<template>
  <div class="app">
    <headers class="herderNav" ref="header" :isChange="false" />

    <div class="bkqdiv">
        <h1>加入备考群</h1>
        <p>扫码添加小助手微信，即可加入备考群，与小伙伴并肩作战，可以提高学习效率哦~</p>
      <div class="bkqImg">
        <img id="bkqimg1" src="@/assets/rightNav/vico.jpg" />
        <img id="bkqimg2" src="@/assets/rightNav/zhushou.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
import headers from "../../components/header.vue";
export default {
  components: {
    headers,
  },
  mounted() {
    this.$refs.header.isTop = false;
    this.$refs.header.headerBack.background = "#ffffff";
    this.$refs.header.herderTits.color = "#666666";
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    this.$refs.header.loginButton = {
      background: "#618aff",
      color: "#fff",
    };
    this.$refs.header.phoneButton = {
      color: "#618aff",
      border: "1px solid #618aff",
    };
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped>
@import '../../assets/css/learntest.css';
</style>



// WEBPACK FOOTER //
// src/view/learntest/learntest.vue